import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { approvedStatusOptions } from '../../constants/approvedStatus';

export const PRICINGS_ERROR = 'PRICINGS_ERROR';
export const PRICINGS_LOADING = 'PRICINGS_LOADING';
export const PRICINGS_SET_DATA = 'PRICINGS_SET_DATA';
export const PRICINGS_TOTAL_COUNT = 'PRICINGS_TOTAL_COUNT';
export const PRICINGS_PAGE = 'PRICINGS_PAGE';
export const PRICINGS_ROWS_PER_PAGE = 'PRICINGS_ROWS_PER_PAGE';
export const PRICINGS_HIDDEN_COLUMNS = 'PRICINGS_HIDDEN_COLUMNS';
export const PRICINGS_SET_FILTER = 'PRICINGS_SET_FILTER';
export const PRICINGS_SET_UI_FILTER = 'PRICINGS_SET_UI_FILTER';

const initialState = {
  data: [],
  isError: false,
  isLoading: false,
  totalCount: 0,
  table: {
    page: 0,
    rowsPerPage: 20,
    hiddenColumns: [],
  },
  filters: {
    search: '',
    statuses: approvedStatusOptions.map((status) => status.value),
    currencies: [],
    channels: [],
    hasPrice: false,
  },
};

const pricings = (state = initialState, action) => {
  switch (action.type) {
    case PRICINGS_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        data: [],
        totalCount: 0,
      };
    case PRICINGS_SET_DATA:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isError: false,
      };
    case PRICINGS_TOTAL_COUNT:
      return {
        ...state,
        totalCount: action.payload,
      };
    case PRICINGS_ROWS_PER_PAGE:
      return {
        ...state,
        table: {
          ...state.table,
          rowsPerPage: action.payload,
          page: 0,
        },
      };
    case PRICINGS_PAGE:
      return {
        ...state,
        table: {
          ...state.table,
          page: action.payload,
        },
      };
    case PRICINGS_HIDDEN_COLUMNS:
      return {
        ...state,
        table: {
          ...state.table,
          hiddenColumns: action.payload,
        },
      };
    case PRICINGS_LOADING:
      return {
        ...state,
        isError: false,
        isLoading: action.payload,
      };
    case PRICINGS_SET_FILTER: {
      const { name, value } = action.payload;
      if (state.filters[name] === value) return state;

      return {
        ...state,
        filters: {
          ...state.filters,
          [name]: value,
        },
        table: {
          ...state.table,
          page: 0,
        },
      };
    }

    default:
      break;
  }

  return state;
};

const persistConfig = {
  key: 'pricings',
  storage,
  whitelist: ['table'],
};

export default persistReducer(persistConfig, pricings);
